import styled from "styled-components";
import Search from "../Search";
import { Colors } from "../../config/Constants";

type Props = {
  handleSearch: (val: string) => void;
  searchQuery: string;
};

const ReportHeader = ({ handleSearch, searchQuery }: Props) => {
  return (
    <StyledReportHeader>
      <StyledPageHeader>Report</StyledPageHeader>
      <ReportHeaderActions>
        <Search
          placeholder="Search"
          onChange={handleSearch}
          value={searchQuery}
        />
      </ReportHeaderActions>
    </StyledReportHeader>
  );
};

const StyledPageHeader = styled.div`
  color: ${Colors.black};
  font-size: 1.25rem;
  font-family: "Poppins-Medium";
  color: ${Colors.black};
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

const StyledReportHeader = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 1.25rem;
  @media only screen and (max-width: 768px) {
    padding: 1rem 1.5rem;
  }
`;

const ReportHeaderActions = styled.div`
  display: flex;
  align-items: center;
  @media only screen and (max-width: 768px) {
    width: 100%;
  }
`;

export default ReportHeader;
